import notificationStreamModule from '../notificationStreamModule';

const notificationStreamConstants = {
  experimentionLayer: 'Notifications.StreamNotificationUX',
  recentGameUpdateRetrievedEventName: 'nsRecentGameUpdateRetrieved',
  acceptFriendGroupCount: 'nsAcceptFriendGroupCount'
};

notificationStreamModule.constant('notificationStreamConstants', notificationStreamConstants);

export default notificationStreamConstants;
